import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20c18800")

_pushScopeId("data-v-20c18800")
const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle"
}
const _hoisted_2 = {
  class: "\n        menu\n        menu-lg-rounded\n        menu-column\n        menu-lg-row\n        menu-state-bg\n        menu-state-icon-primary\n        menu-state-bullet-primary\n        menu-arrow-gray-400\n        fw-bold\n        my-5 my-lg-0\n        align-items-stretch\n      ",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_4 = { class: "menu-title" }
const _hoisted_5 = {
  key: 1,
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_6 = { class: "menu-title" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_8 = { class: "\n              menu-sub\n              menu-sub-lg-down-accordion\n              menu-sub-lg-dropdown\n              menu-rounded-0\n              py-lg-4\n              w-lg-225px\n            " }
const _hoisted_9 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_10 = { class: "menu-icon" }
const _hoisted_11 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_12 = { class: "menu-title" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_14 = { class: "\n                    menu-sub\n                    menu-sub-lg-down-accordion\n                    menu-sub-lg-dropdown\n                    menu-active-bg\n                    py-lg-4\n                    w-lg-225px\n                  " }
const _hoisted_15 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_17 = { class: "menu-title" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_19 = { class: "\n                          menu-sub\n                          menu-sub-lg-down-accordion\n                          menu-sub-lg-dropdown\n                          menu-active-bg\n                          py-lg-4\n                          w-lg-225px\n                        " }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_21 = { class: "menu-title" }
const _hoisted_22 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_24 = { class: "menu-title" }
const _hoisted_25 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_26 = { class: "menu-icon" }
const _hoisted_27 = { class: "svg-icon svg-icon-2" }
const _hoisted_28 = { class: "menu-title" }
const _hoisted_29 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_30 = { class: "menu-link py-3" }
const _hoisted_31 = { class: "menu-title" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_33 = { class: "\n            menu-sub\n            menu-sub-lg-down-accordion\n            menu-sub-lg-dropdown\n            menu-rounded-0\n            py-lg-4\n            w-lg-225px\n          " }
const _hoisted_34 = { class: "menu-item" }
const _hoisted_35 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/utilities"
}
const _hoisted_36 = { class: "menu-icon" }
const _hoisted_37 = {
  key: 0,
  class: "bi bi-box fs-3"
}
const _hoisted_38 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_39 = { class: "menu-title" }
const _hoisted_40 = { class: "menu-item" }
const _hoisted_41 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/doc-overview"
}
const _hoisted_42 = { class: "menu-icon" }
const _hoisted_43 = {
  key: 0,
  class: "bi bi-card-text fs-3"
}
const _hoisted_44 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_45 = { class: "menu-title" }
const _hoisted_46 = { class: "menu-item" }
const _hoisted_47 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/changelog"
}
const _hoisted_48 = { class: "menu-icon" }
const _hoisted_49 = {
  key: 0,
  class: "bi bi-journal-code fs-3"
}
const _hoisted_50 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_51 = { class: "menu-title" }
const _hoisted_52 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_53 = { class: "menu-link py-3" }
const _hoisted_54 = { class: "menu-title" }
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_56 = {
  class: "\n            menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown\n            w-100 w-lg-600px\n            p-5 p-lg-5\n          ",
  style: {}
}
const _hoisted_57 = {
  class: "row",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_58 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_59 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_60 = { class: "menu-item" }
const _hoisted_61 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_63 = { class: "menu-title" }
const _hoisted_64 = { class: "menu-item" }
const _hoisted_65 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_67 = { class: "menu-title" }
const _hoisted_68 = { class: "menu-item" }
const _hoisted_69 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_71 = { class: "menu-title" }
const _hoisted_72 = { class: "menu-item" }
const _hoisted_73 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_75 = { class: "menu-title" }
const _hoisted_76 = { class: "menu-item" }
const _hoisted_77 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_79 = { class: "menu-title" }
const _hoisted_80 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_81 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_82 = { class: "menu-item" }
const _hoisted_83 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_85 = { class: "menu-title" }
const _hoisted_86 = { class: "menu-item" }
const _hoisted_87 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_89 = { class: "menu-title" }
const _hoisted_90 = { class: "menu-item" }
const _hoisted_91 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_93 = { class: "menu-title" }
const _hoisted_94 = { class: "menu-item" }
const _hoisted_95 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_97 = { class: "menu-title" }
const _hoisted_98 = { class: "menu-item" }
const _hoisted_99 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_100 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_101 = { class: "menu-title" }
const _hoisted_102 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_103 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_104 = { class: "menu-item" }
const _hoisted_105 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_106 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_107 = { class: "menu-title" }
const _hoisted_108 = { class: "menu-item" }
const _hoisted_109 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_110 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_111 = { class: "menu-title" }
const _hoisted_112 = { class: "menu-item" }
const _hoisted_113 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_114 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_115 = { class: "menu-title" }
const _hoisted_116 = { class: "menu-item" }
const _hoisted_117 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_118 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_119 = { class: "menu-title" }
const _hoisted_120 = { class: "menu-item" }
const _hoisted_121 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_122 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_123 = { class: "menu-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createBlock(_Fragment, { key: i }, [
          (!item.heading)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withId(({ href, navigate, isActive, isExactActive }) => [
                            _createVNode("a", {
                              href: href,
                              class: ["menu-link py-3", [isActive && 'active', isExactActive && 'active']],
                              onClick: navigate
                            }, [
                              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ], 10, ["href", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (item.heading)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("span", {
                  class: ["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }]
                }, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.translate(item.heading)), 1),
                  _hoisted_7
                ], 2),
                _createVNode("div", _hoisted_8, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                    return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                      (menuItem.sectionTitle)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode("span", {
                              class: ["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }]
                            }, [
                              _createVNode("span", _hoisted_10, [
                                (_ctx.headerMenuIcons === 'font')
                                  ? (_openBlock(), _createBlock("i", {
                                      key: 0,
                                      class: [menuItem.fontIcon, "bi fs-3"]
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (_ctx.headerMenuIcons === 'svg')
                                  ? (_openBlock(), _createBlock("span", _hoisted_11, [
                                      _createVNode(_component_inline_svg, {
                                        src: menuItem.svgIcon
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                              _hoisted_13
                            ], 2),
                            _createVNode("div", _hoisted_14, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                                return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                                  (menuItem1.sectionTitle)
                                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                        _createVNode("span", {
                                          class: ["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem1.route) }]
                                        }, [
                                          _hoisted_16,
                                          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.translate(menuItem1.sectionTitle)), 1),
                                          _hoisted_18
                                        ], 2),
                                        _createVNode("div", _hoisted_19, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                            return (_openBlock(), _createBlock("div", {
                                              key: l,
                                              class: "menu-item"
                                            }, [
                                              _createVNode(_component_router_link, {
                                                class: "menu-link py-3",
                                                "active-class": "active",
                                                to: menuItem2.route
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_20,
                                                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.translate(menuItem2.heading)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (menuItem1.heading)
                                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                                        _createVNode(_component_router_link, {
                                          class: "menu-link py-3",
                                          to: menuItem1.route
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_23,
                                            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.translate(menuItem1.heading)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (menuItem.heading)
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              class: "menu-link py-3",
                              to: menuItem.route
                            }, {
                              default: _withId(() => [
                                _createVNode("span", _hoisted_26, [
                                  _createVNode("span", _hoisted_27, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/layouts/lay009.svg" })
                                  ])
                                ]),
                                _createVNode("span", _hoisted_28, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createVNode("div", _hoisted_29, [
        _createVNode("span", _hoisted_30, [
          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.translate("resources")), 1),
          _hoisted_32
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("a", _hoisted_35, [
              _createVNode("span", _hoisted_36, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createBlock("i", _hoisted_37))
                  : _createCommentVNode("", true),
                (_ctx.headerMenuIcons === 'svg')
                  ? (_openBlock(), _createBlock("span", _hoisted_38, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen002.svg" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("span", _hoisted_39, _toDisplayString(_ctx.translate("components")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_40, [
            _createVNode("a", _hoisted_41, [
              _createVNode("span", _hoisted_42, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createBlock("i", _hoisted_43))
                  : (_ctx.headerMenuIcons === 'svg')
                    ? (_openBlock(), _createBlock("span", _hoisted_44, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createVNode("span", _hoisted_45, _toDisplayString(_ctx.translate("documentation")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode("a", _hoisted_47, [
              _createVNode("span", _hoisted_48, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createBlock("i", _hoisted_49))
                  : (_ctx.headerMenuIcons === 'svg')
                    ? (_openBlock(), _createBlock("span", _hoisted_50, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/coding/cod003.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createVNode("span", _hoisted_51, _toDisplayString(_ctx.translate("changelog")) + " v" + _toDisplayString(_ctx.version), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_52, [
        _createVNode("span", _hoisted_53, [
          _createVNode("span", _hoisted_54, _toDisplayString(_ctx.translate("megaMenu")), 1),
          _hoisted_55
        ]),
        _createVNode("div", _hoisted_56, [
          _createVNode("div", _hoisted_57, [
            _createVNode("div", _hoisted_58, [
              _createVNode("div", _hoisted_59, [
                _createVNode("div", _hoisted_60, [
                  _createVNode("a", _hoisted_61, [
                    _hoisted_62,
                    _createVNode("span", _hoisted_63, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_64, [
                  _createVNode("a", _hoisted_65, [
                    _hoisted_66,
                    _createVNode("span", _hoisted_67, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_68, [
                  _createVNode("a", _hoisted_69, [
                    _hoisted_70,
                    _createVNode("span", _hoisted_71, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_72, [
                  _createVNode("a", _hoisted_73, [
                    _hoisted_74,
                    _createVNode("span", _hoisted_75, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_76, [
                  _createVNode("a", _hoisted_77, [
                    _hoisted_78,
                    _createVNode("span", _hoisted_79, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _createVNode("div", _hoisted_82, [
                  _createVNode("a", _hoisted_83, [
                    _hoisted_84,
                    _createVNode("span", _hoisted_85, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_86, [
                  _createVNode("a", _hoisted_87, [
                    _hoisted_88,
                    _createVNode("span", _hoisted_89, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_90, [
                  _createVNode("a", _hoisted_91, [
                    _hoisted_92,
                    _createVNode("span", _hoisted_93, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_94, [
                  _createVNode("a", _hoisted_95, [
                    _hoisted_96,
                    _createVNode("span", _hoisted_97, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_98, [
                  _createVNode("a", _hoisted_99, [
                    _hoisted_100,
                    _createVNode("span", _hoisted_101, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_102, [
              _createVNode("div", _hoisted_103, [
                _createVNode("div", _hoisted_104, [
                  _createVNode("a", _hoisted_105, [
                    _hoisted_106,
                    _createVNode("span", _hoisted_107, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_108, [
                  _createVNode("a", _hoisted_109, [
                    _hoisted_110,
                    _createVNode("span", _hoisted_111, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_112, [
                  _createVNode("a", _hoisted_113, [
                    _hoisted_114,
                    _createVNode("span", _hoisted_115, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_116, [
                  _createVNode("a", _hoisted_117, [
                    _hoisted_118,
                    _createVNode("span", _hoisted_119, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_120, [
                  _createVNode("a", _hoisted_121, [
                    _hoisted_122,
                    _createVNode("span", _hoisted_123, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})